<template>
  <svg class="icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 7.84783L5 7.5V4H17.5L17.0326 6.57092C16.7378 8.19223 15.1904 9.27225 13.5669 8.9899L10.75 8.5M7 7.84783L4 15.5L6.31118 16.6556C6.75567 16.8778 7.26501 16.9337 7.74713 16.8132V16.8132C8.51455 16.6214 9.10693 16.0112 9.27597 15.2384L10.75 8.5M7 7.84783L10.75 8.5" stroke-width="1.5" stroke-linejoin="round"/>
  </svg>
</template>